export enum PlaylistControllerEvents {
    PlaylistChange = 'PlaylistController.PlaylistChange',
    PlaylistItemChange = 'PlaylistController.PlaylistItemChange'
}
